import { Component } from '@angular/core';

@Component({
  selector: 'app-osk-subscriptions',
  templateUrl: './osk-subscriptions.component.html',
  styleUrl: './osk-subscriptions.component.scss',
})
export class OskSubscriptionsComponent {}
